module.exports = __webpack_public_path__ + "img/tabbar00_.d0c83c7e.png";